export const UniqueId = () => Math.round(new Date().getTime() + (Math.random() * 100)) + '';
